module.exports = __webpack_public_path__ + "static/media/analytics.91e86ad4.svg";